import { render, staticRenderFns } from "./researchCenter.vue?vue&type=template&id=51af77fa&scoped=true&lang=pug"
import script from "./researchCenter.vue?vue&type=script&lang=js"
export * from "./researchCenter.vue?vue&type=script&lang=js"
import style0 from "./researchCenter.vue?vue&type=style&index=0&id=51af77fa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51af77fa",
  null
  
)

export default component.exports